import { Form, Input } from 'antd';
import { validate } from 'shared/helpers';
import { LockOutlined } from '@ant-design/icons';
import { ChangeEvent, FC, useEffect } from 'react';
import { Rule } from 'antd/lib/form';

const { Item } = Form;
const { Password } = Input;

type TProps = {
  name?: string;
  placeholder?: string;
  onChange?: (val: string) => void;
  toValidate?: boolean;
  rules?: Rule[];
};

export const PasswordField: FC<TProps> = ({
  name = 'password',
  placeholder = 'Пароль',
  onChange,
  toValidate = true,
  rules = [],
}) => {
  return (
    <Item
      name={name}
      rules={
        toValidate
          ? [
              { required: true, message: 'Требуется ввод пароля' },
              { validator: validate.validateLoginPassword },
              ...rules,
            ]
          : []
      }
      normalize={e => e.trim()}
    >
      <Password
        type="password"
        prefix={<LockOutlined className="icon" />}
        placeholder={placeholder}
        maxLength={30}
        tabIndex={2}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange?.(e.target.value)}
      />
    </Item>
  );
};
